var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "componentDetailsModal",
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.component_details"),
      },
      on: { show: _vm.initializeSelectedLicense },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                      expression: "PERMISSIONS.PORTFOLIO_MANAGEMENT",
                    },
                  ],
                  attrs: { size: "md", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteComponent()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.delete")))]
              ),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.componentPropertiesModal",
                      modifiers: { componentPropertiesModal: true },
                    },
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: _vm.PERMISSIONS.VIEW_PORTFOLIO,
                      expression: "PERMISSIONS.VIEW_PORTFOLIO",
                    },
                  ],
                  attrs: { size: "md", variant: "outline-primary" },
                },
                [_vm._v(_vm._s(_vm.$t("message.properties")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                      expression: "PERMISSIONS.PORTFOLIO_MANAGEMENT",
                    },
                  ],
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateComponent()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.update")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: { border: "0", padding: "0" },
        },
        [
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              attrs: { active: "" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-cube" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.identity"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-name-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "true",
                      feedback: "true",
                      autofocus: "false",
                      label: _vm.$t("message.component_name"),
                      tooltip: this.$t("message.component_name_desc"),
                      "feedback-text": _vm.$t(
                        "message.required_component_name"
                      ),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "name", $$v)
                      },
                      expression: "component.name",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-version-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "true",
                      feedback: "true",
                      autofocus: "false",
                      label: _vm.$t("message.version"),
                      tooltip: this.$t("message.component_version_desc"),
                      "feedback-text": _vm.$t(
                        "message.required_component_version"
                      ),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.version,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "version", $$v)
                      },
                      expression: "component.version",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-group-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.component_namespace_group_vendor"),
                      tooltip: this.$t("message.component_group_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.group,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "group", $$v)
                      },
                      expression: "component.group",
                    },
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.component_classification")) +
                      "\n        "
                  ),
                  _c(
                    "b-badge",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: {
                        variant: _vm.component.isInternal
                          ? "tab-total"
                          : "tab-info",
                        title: _vm.$t("message.component_classification_desc"),
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.component.isInternal ? "INTERNAL" : "EXTERNAL"
                        )
                      ),
                    ]
                  ),
                  _c("p"),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-author-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.component_author"),
                      tooltip: this.$t("message.component_author_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.author,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "author", $$v)
                      },
                      expression: "component.author",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-purl-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.package_url_full"),
                      tooltip: this.$t("message.component_package_url_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.purl,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "purl", $$v)
                      },
                      expression: "component.purl",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-cpe-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.cpe_full"),
                      tooltip: _vm.$t("message.component_cpe_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.cpe,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "cpe", $$v)
                      },
                      expression: "component.cpe",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-swidTagId-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.swid_tagid"),
                      tooltip: _vm.$t("message.component_swid_tagid_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.swidTagId,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "swidTagId", $$v)
                      },
                      expression: "component.swidTagId",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-uuid",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "false",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                      disabled: "true",
                      label: _vm.$t("message.object_identifier"),
                      tooltip: this.$t("message.object_identifier_desc"),
                      readonly: true,
                    },
                    model: {
                      value: _vm.component.uuid,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "uuid", $$v)
                      },
                      expression: "component.uuid",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-caret-square-o-right" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.extended"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-select", {
                    attrs: {
                      id: "component-classifier-input",
                      required: "true",
                      options: _vm.sortAvailableClassifiers,
                      label: _vm.$t("message.classifier"),
                      tooltip: _vm.$t("message.component_classifier_desc"),
                      disabled: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.classifier,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "classifier", $$v)
                      },
                      expression: "component.classifier",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-filename-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.filename"),
                      tooltip: _vm.$t("message.component_filename_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.filename,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "filename", $$v)
                      },
                      expression: "component.filename",
                    },
                  }),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "component-description-form-group",
                        label: this.$t("message.description"),
                        "label-for": "component-description-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "component-description-description",
                          rows: "3",
                          readonly: this.isNotPermitted(
                            _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                          ),
                        },
                        model: {
                          value: _vm.component.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.component, "description", $$v)
                          },
                          expression: "component.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-balance-scale" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.legal"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-select", {
                    attrs: {
                      id: "component-license-input",
                      required: "false",
                      options: _vm.selectableLicenses,
                      label: _vm.$t("message.license"),
                      tooltip: _vm.$t("message.component_spdx_license_desc"),
                      disabled: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.selectedLicense,
                      callback: function ($$v) {
                        _vm.selectedLicense = $$v
                      },
                      expression: "selectedLicense",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-license-expression",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.license_expression"),
                      tooltip: _vm.$t(
                        "message.component_license_expression_desc"
                      ),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.licenseExpression,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "licenseExpression", $$v)
                      },
                      expression: "component.licenseExpression",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-license-url-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("message.license_url"),
                      tooltip: _vm.$t("message.component_license_url_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.licenseUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "licenseUrl", $$v)
                      },
                      expression: "component.licenseUrl",
                    },
                  }),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "component-copyright-form-group",
                        label: this.$t("message.copyright"),
                        "label-for": "component-copyright-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "component-description-description",
                          rows: "3",
                          readonly: this.isNotPermitted(
                            _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                          ),
                        },
                        model: {
                          value: _vm.component.copyright,
                          callback: function ($$v) {
                            _vm.$set(_vm.component, "copyright", $$v)
                          },
                          expression: "component.copyright",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-barcode" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.hashes"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-md5-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("hashes.md5"),
                      tooltip: _vm.$t("message.component_hash_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.md5,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "md5", $$v)
                      },
                      expression: "component.md5",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-sha1-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("hashes.sha_1"),
                      tooltip: _vm.$t("message.component_hash_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.sha1,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "sha1", $$v)
                      },
                      expression: "component.sha1",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-sha256-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("hashes.sha_256"),
                      tooltip: _vm.$t("message.component_hash_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.sha256,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "sha256", $$v)
                      },
                      expression: "component.sha256",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-sha512-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("hashes.sha_512"),
                      tooltip: _vm.$t("message.component_hash_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.sha512,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "sha512", $$v)
                      },
                      expression: "component.sha512",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-sha3256-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("hashes.sha3_256"),
                      tooltip: _vm.$t("message.component_hash_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.sha3_256,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "sha3_256", $$v)
                      },
                      expression: "component.sha3_256",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "component-sha3512-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      required: "false",
                      label: _vm.$t("hashes.sha3_512"),
                      tooltip: _vm.$t("message.component_hash_desc"),
                      readonly: this.isNotPermitted(
                        _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                      ),
                    },
                    model: {
                      value: _vm.component.sha3_512,
                      callback: function ($$v) {
                        _vm.$set(_vm.component, "sha3_512", $$v)
                      },
                      expression: "component.sha3_512",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.component.supplier
            ? _c(
                "b-tab",
                {
                  staticClass: "body-bg-color",
                  staticStyle: { border: "0", padding: "0" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "fa fa-building-o" }),
                            _vm._v(
                              "\n        " + _vm._s(_vm.$t("message.supplier"))
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3424175726
                  ),
                },
                [
                  _c(
                    "b-card",
                    [
                      _c("b-input-group-form-input", {
                        attrs: {
                          id: "component-supplier-name-input",
                          "input-group-size": "mb-3",
                          type: "text",
                          required: "false",
                          readonly: "",
                          label: _vm.$t("message.supplier_name"),
                          tooltip: this.$t(
                            "message.component_supplier_name_desc"
                          ),
                        },
                        model: {
                          value: _vm.component.supplier.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.component.supplier, "name", $$v)
                          },
                          expression: "component.supplier.name",
                        },
                      }),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "supplierUrlsTable-Fieldset",
                            label: this.$t("message.urls"),
                            "label-for": "supplierUrlsTable",
                          },
                        },
                        [
                          _c("bootstrap-table", {
                            ref: "supplierUrlsTable",
                            attrs: {
                              id: "supplierUrlsTable",
                              columns: _vm.supplierUrlsTableColumns,
                              data: _vm.component.supplier.urls,
                              options: _vm.supplierUrlsTableOptions,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "supplierContactsTable-Fieldset",
                            label: this.$t("message.contacts"),
                            "label-for": "contactsTable",
                          },
                        },
                        [
                          _c("bootstrap-table", {
                            ref: "supplierContactsTable",
                            attrs: {
                              id: "supplierContactsTable",
                              columns: _vm.supplierContactsTableColumns,
                              data: _vm.component.supplier.contacts,
                              options: _vm.supplierContactsTableOptions,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-external-link" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.external_references"))
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("bootstrap-table", {
                    ref: "referencesTable",
                    attrs: {
                      columns: _vm.referencesTableColumns,
                      data: _vm.component.externalReferences,
                      options: _vm.referencesTableOptions,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-file-text-o" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.notes"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "component-notes-form-group",
                        label: this.$t("message.notes"),
                        "label-for": "component-notes-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "component-notes-description",
                          rows: "3",
                          readonly: this.isNotPermitted(
                            _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT
                          ),
                        },
                        model: {
                          value: _vm.component.notes,
                          callback: function ($$v) {
                            _vm.$set(_vm.component, "notes", $$v)
                          },
                          expression: "component.notes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }